import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const MarginPositions = ({ positions, onClose }) => (
  <div className="rounded-xl border border-border overflow-hidden" style={{ background: "var(--color-card)" }}>
    <div className="flex items-center justify-between px-4 md:px-6 py-4 border-b border-border">
      <div className="flex items-center gap-2">
        <Icon name="Layers" size={18} color="var(--color-accent)" />
        <h3 className="font-heading text-base font-semibold text-foreground">Margin Positions</h3>
      </div>
      <span className="font-caption text-xs text-muted-foreground">{positions?.length} open</span>
    </div>
    {positions?.length === 0 ? (
      <div className="flex flex-col items-center justify-center py-10 text-muted-foreground">
        <Icon name="Layers" size={32} color="var(--color-muted-foreground)" />
        <p className="font-caption text-sm mt-2">No margin positions open</p>
      </div>
    ) : (
      <div className="divide-y divide-border/50">
        {positions?.map(p => {
          const equityRatio = (p?.equity / p?.positionValue) * 100;
          const isWarning = equityRatio < 30;
          const isDanger = equityRatio < 20;
          return (
            <div key={p?.id} className="p-4 md:p-5">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <div className={`w-9 h-9 rounded-md flex items-center justify-center text-xs font-heading font-bold ${isDanger ? "bg-red-500/20 text-red-400" : isWarning ? "bg-amber-500/20 text-amber-400" : "bg-primary/10 text-primary"}`}>
                    {p?.ticker?.slice(0, 2)}
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="font-heading text-sm font-semibold text-foreground">{p?.ticker}</span>
                      <span className="font-caption text-xs px-1.5 py-0.5 rounded" style={{ background: "var(--color-muted)", color: "var(--color-muted-foreground)" }}>{p?.leverage}x</span>
                      {isDanger && <span className="font-caption text-xs px-1.5 py-0.5 rounded bg-red-500/20 text-red-400">LIQUIDATION RISK</span>}
                      {isWarning && !isDanger && <span className="font-caption text-xs px-1.5 py-0.5 rounded bg-amber-500/20 text-amber-400">MARGIN CALL</span>}
                    </div>
                    <div className="font-caption text-xs text-muted-foreground">{p?.direction} · {p?.qty} shares</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 sm:gap-6">
                  <div className="text-right">
                    <div className="font-caption text-xs text-muted-foreground">Position Value</div>
                    <div className="font-data text-sm font-semibold text-foreground">${p?.positionValue?.toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                  </div>
                  <div className="text-right">
                    <div className="font-caption text-xs text-muted-foreground">Equity</div>
                    <div className={`font-data text-sm font-semibold ${isDanger ? "text-red-400" : isWarning ? "text-amber-400" : "text-green-400"}`}>${p?.equity?.toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                  </div>
                  <Button variant={isDanger ? "destructive" : "outline"} size="sm" onClick={() => onClose(p)}>Close</Button>
                </div>
              </div>
              <div className="mt-3">
                <div className="flex justify-between text-xs font-caption text-muted-foreground mb-1">
                  <span>Equity Ratio: {equityRatio?.toFixed(1)}%</span>
                  <span>Maintenance: {p?.maintenanceReq}%</span>
                </div>
                <div className="h-1.5 rounded-full overflow-hidden" style={{ background: "var(--color-muted)" }}>
                  <div className="h-full rounded-full transition-all duration-500" style={{ width: `${Math.min(equityRatio, 100)}%`, background: isDanger ? "var(--color-error)" : isWarning ? "var(--color-warning)" : "var(--color-success)" }} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    )}
  </div>
);

export default MarginPositions;